module.exports = __webpack_public_path__ + "static/sinead-slideshow-01-c60d1ac437b91e95945954e936020e7f.jpg";